import React, { Component } from 'react';
import { Button, Col, Container, InputGroup, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

class Page500 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <span className="clearfix">
                <h1 className="float-left display-3 mr-4">500</h1>
                <h4 className="pt-3">Houston, we have a problem!</h4>
                <p className="text-muted float-left">The page you are looking for is temporarily unavailable.</p>
              </span>
              <InputGroup className="input-prepend">
                <Link className="link-button" style={{ width: 100 + '%' }} to="/">
                  <Button color="secondary" block>Back to home</Button>
                </Link>
              </InputGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page500;



// WEBPACK FOOTER //
// ./src/containers/Page500/Page500.js